import { weekIdOf } from '@brimstone/shared';
import { Link } from 'react-router';
import { Panel, SecondaryButton } from '../../components/ui';
import { useRegenerateDigest } from '../../lib/digest';
import { useNow } from '../../lib/time';
import { useReset } from '../../lib/tracking';

/** The weekly digest (SPEC §6.11): written after each reset; this week's can be written now. */
export function DigestPanel() {
  const reset = useReset().data?.reset;
  const now = useNow();
  const regenerate = useRegenerateDigest();
  const weekId = reset ? weekIdOf(new Date(now), reset) : null;
  return (
    <Panel title="Weekly digest" level="side">
      <div className="flex flex-col gap-3 px-4 py-3">
        <p className="m-0 text-secondary text-muted">
          Written 15 minutes after each reset, in the app only. Regenerating rewrites a week from
          what is stored now.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <SecondaryButton
            type="button"
            disabled={!weekId || regenerate.isPending}
            onClick={() => weekId && regenerate.mutate(weekId)}
          >
            {regenerate.isPending ? 'Writing…' : 'Regenerate this week'}
          </SecondaryButton>
          {regenerate.isSuccess && (
            <Link to={`/digest/${regenerate.data.digest.weekId}`} className="text-compact">
              Open it
            </Link>
          )}
          {regenerate.isError && (
            <span className="text-secondary text-danger">{regenerate.error.message}</span>
          )}
        </div>
      </div>
    </Panel>
  );
}
